import { NuggetComment } from '@shared/models/nugget-comment.model';
import { Nugget } from '@shared/models/sequence.model';

export class LoadNuggetComments {
    static readonly type = '[Nugget Interaction] Load nugget comments';

    constructor(public payload: { nugget: Nugget }) {}
}

export class AddNuggetComment {
    static readonly type = '[Nugget Interaction] Add nugget comment';

    constructor(public payload: { nugget: Nugget; text: string }) {}
}

export class DeleteNuggetComment {
    static readonly type = '[Nugget Interaction] Delete nugget comment';

    constructor(public payload: { nugget: Nugget; comment: NuggetComment }) {}
}

export class DownloadNuggetDocument {
    static readonly type = '[Nugget Interaction] Download nugget document';

    constructor(public payload: { nugget: Nugget }) {}
}
